import { workerstationService } from "@workerstation/shared/effect/service";
import { Context, Effect, Option, Schema } from "effect";
import type { AuthorizationError, RoleGrant, StoredStationSession } from "./model.ts";

export const StationSessionStorageError = /* @__PURE__ */ (() => { class StationSessionStorageError extends Schema.TaggedError<StationSessionStorageError>()("StationSessionStorageError", {
  reason: Schema.Literals(["unavailable", "invalid-output"]), status: Schema.tag(500)
}) {} return StationSessionStorageError; })();
export type StationSessionStorageError = InstanceType<typeof StationSessionStorageError>;
export type StationSessionStorageFailure = StationSessionStorageError | AuthorizationError;
export const sessionStorageUnavailable = () => new StationSessionStorageError({ reason: "unavailable" });

export interface StationSessionClient {
  readonly grant: (principalId: string) => Effect.Effect<Option.Option<RoleGrant>, StationSessionStorageFailure>;
  readonly session: (hash: string) => Effect.Effect<Option.Option<StoredStationSession>, StationSessionStorageFailure>;
  readonly rotate: (previousHash: string | null, session: StoredStationSession) => Effect.Effect<void, StationSessionStorageFailure>;
}
export class StationSessionStorage extends workerstationService<StationSessionStorage, {
  readonly select: (stationId: string) => Effect.Effect<StationSessionClient, StationSessionStorageFailure>;
}>()("StationSessionStorage") {}
